module.exports = __webpack_public_path__ + "img/appointment_text.caf08b10.png";